import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, LightbulbIcon, DollarSignIcon, MonitorIcon, TrendingUpIcon } from 'lucide-react';
export const BenefitsSection = () => {
  const benefits = [{
    icon: <LightbulbIcon size={24} className="text-blue-400" data-id="element-84" />,
    title: 'Crea tu producto digital sin invertir miles de dólares',
    description: 'Aprende a desarrollar productos digitales de alta calidad utilizando herramientas de IA, sin necesidad de grandes inversiones ni conocimientos técnicos avanzados.'
  }, {
    icon: <TrendingUpIcon size={24} className="text-purple-400" data-id="element-85" />,
    title: 'Ganancias de casi 100% sin inventario físico',
    description: 'Al ser todo digital, no necesitas invertir en inventario, almacenamiento o envíos. Cada venta es prácticamente ganancia pura, maximizando tus beneficios desde el primer día.'
  }, {
    icon: <DollarSignIcon size={24} className="text-pink-400" data-id="element-86" />,
    title: 'Vende sin mostrar tu cara',
    description: 'Aprende estrategias efectivas para promocionar y vender tus productos digitales manteniendo tu privacidad. No necesitas ser el rostro de tu negocio para tener éxito en el mundo digital.'
  }];
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0
    }
  };
  return <section className="py-12 px-4 relative" data-id="element-87">
      {/* Efecto de luz */}
      <div className="absolute -left-40 top-1/2 -translate-y-1/2 w-80 h-80 bg-blue-500/20 blur-[120px] rounded-full" data-id="element-88"></div>
      <div className="container mx-auto max-w-6xl relative z-10" data-id="element-89">
        <div className="text-center mb-12" data-id="element-90">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400" data-id="element-91">
            Lo que aprenderás en esta clase
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} viewport={{
          once: true
        }} className="text-gray-300 max-w-2xl mx-auto" data-id="element-92">
            Descubre el método completo para empezar a vender en internet sin
            complicaciones
          </motion.p>
        </div>
        <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
        once: true
      }} className="grid md:grid-cols-3 gap-8" data-id="element-93">
          {benefits.map((benefit, index) => <motion.div key={index} variants={item} className="bg-gradient-to-r from-gray-900/80 to-gray-800/50 backdrop-blur-sm p-6 rounded-xl border border-gray-800 hover:border-purple-500/50 transition-all duration-300" data-id="element-94">
              <div className="mb-4 flex items-center gap-3" data-id="element-95">
                <div className="p-3 rounded-full bg-gray-800/80 border border-gray-700" data-id="element-96">
                  {benefit.icon}
                </div>
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-97">{benefit.title}</h3>
              <p className="text-gray-400" data-id="element-98">{benefit.description}</p>
            </motion.div>)}
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} viewport={{
        once: true
      }} className="mt-12 bg-gradient-to-r from-blue-900/20 via-purple-900/20 to-black backdrop-blur-sm p-8 rounded-xl border border-gray-800" data-id="element-99">
          <h3 className="text-2xl md:text-3xl font-bold mb-6 text-center" data-id="element-100">
            Empieza a vender en internet
          </h3>
          <div className="grid md:grid-cols-3 gap-6 max-w-3xl mx-auto" data-id="element-101">
            {[{
            text: 'Sin inventario',
            icon: <CheckCircleIcon size={20} className="text-green-400" data-id="element-102" />
          }, {
            text: 'Sin mostrar tu cara',
            icon: <CheckCircleIcon size={20} className="text-green-400" data-id="element-103" />
          }, {
            text: 'Sin complicaciones',
            icon: <CheckCircleIcon size={20} className="text-green-400" data-id="element-104" />
          }].map((item, index) => <div key={index} className="flex items-center gap-3 bg-gray-900/50 p-4 rounded-lg" data-id="element-105">
                {item.icon}
                <span className="font-medium" data-id="element-106">{item.text}</span>
              </div>)}
          </div>
          <div className="mt-8 text-center text-gray-300" data-id="element-107">
            <p className="max-w-3xl mx-auto" data-id="element-108">
              Vender tu propio producto digital es el mejor método para vender
              en internet si estás empezando. Aprende cómo hacerlo de forma
              efectiva y sin complicaciones.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};